<template>
  <MAFieldWrapper
    :id="id"
    :label="label"
    :value="value"
    :disabled="disabled"
    :required="required"
    :readonly="!!readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <template #default="{ validator, handleBlur }">
      <Calendar
        :id="id"
        v-model="value"
        :invalid="validator?.$dirty && validator?.$invalid"
        time-only
        :disabled="disabled"
        :readonly-input="readonly"
        hour-format="12"
        :placeholder="placeholder || '11:45 pm'"
        fluid
        @blur="onBlur(handleBlur)"
      />
    </template>
  </MAFieldWrapper>
</template>

<script setup lang="ts">
import type { AnyFn } from "@vueuse/core";
import Calendar from "@/volt/DatePicker.vue";
import { ulid } from "ulid";
import MAFieldWrapper from "../primevueComponents/MAFieldWrapper.vue";

const props = withDefaults(
  defineProps<{
    id?: string;
    label?: string;
    placeholder?: string;
    modelValue?: Date;
    readonly?: boolean;
    required?: boolean;
    disabled?: boolean;
    rules?: Record<string, any>;
  }>(),
  {
    id: ulid(),
  }
);

const emit = defineEmits<{
  "update:modelValue": [string];
  blur: [];
}>();

const value = useVModel(props, "modelValue", emit);

function onBlur(cb?: AnyFn) {
  if (cb) cb();
  emit("blur");
}
</script>
